import React from 'react';
import styled from 'styled-components';
import theme from '@/styles/theme';
import StyledButton from '../atoms/StyledButton';
import ModalContainer, { ButtonGroup } from '../modal/ModalContainer';

type ConfirmModalProps = {
	onConfirm: () => void;
	onCancel: () => void;
}

const ConfirmModal = ({
	onConfirm,
	onCancel
}: ConfirmModalProps) => {
	return (
		<ModalContainer
			title="페이지 이동 확인"
			onClose={onCancel}>
            <Message>
	            페이지 이동 시 입력된 정보가 모두 사라집니다.<br />
	            정말로 이동하시겠습니까?
            </Message>
            <ButtonGroup>
	            <StyledButton
		            title="취소"
				    width={140}
				    fontColor={theme.colors.blackColor}
				    border={`1px solid ${theme.colors.lightGrayBorder}`}
				    bgColor={theme.colors.whiteColor}
		            onClick={onCancel}
	            />
                <StyledButton
				    title="이동"
		            width={140}
		            fontColor={theme.colors.whiteColor}
		            border="none"
		            bgColor={theme.colors.blackColor}
				    onClick={onConfirm}
			    />
            </ButtonGroup>
		</ModalContainer>
	);
};

export default ConfirmModal;

const Message = styled.p`
  ${theme.typography.label};
  color: ${theme.colors.deepGrayFontColor};
  white-space: pre-wrap;
`;
